import { createFileRoute } from '@tanstack/react-router'
import { TemplatesPageClient } from '#/components/templates/TemplatesPageClient'

export const Route = createFileRoute('/_authenticated/$slug/settings/templates')({
  component: TemplatesPageClient,
})
